// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6157":"css/admin-app.6673","9267":"css/app.6673"}[chunkId] + ".css";
};